import { cn } from "@components/utils/utils";
import type { ReactNode } from "react";

const variants = {
  success: "border-green-500 bg-green-50 text-green-800 dark:bg-green-950/50 dark:text-green-200",
  warning: "border-yellow-500 bg-yellow-50 text-yellow-800 dark:bg-yellow-950/50 dark:text-yellow-200",
  error: "border-red-500 bg-red-50 text-red-800 dark:bg-red-950/50 dark:text-red-200",
  info: "border-blue-500 bg-blue-50 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200",
} as const;

interface AlertProps {
  children: ReactNode;
  variant?: keyof typeof variants;
  className?: string;
}

export const Alert = ({ children, variant = "success", className }: AlertProps) => {
  return <div className={cn("rounded-md border-l-4 p-4", variants[variant], className)}>{children}</div>;
};
